import { memo, useMemo } from 'react';
import { View } from 'foundations-components/components/View';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CALL_FROM_BROWSER, CALL_FROM_PHONE, CALL_FROM_HUBSPOT_APP } from 'calling-internal-common/constants/CallMethods';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DropdownMenuOption } from 'foundations-components/transitional/components/Dropdown';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Flex } from 'foundations-components/components/Flex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MAX_OPTIONS = 4;
const StyledHoverDiv = styled.div.withConfig({
  displayName: "CallDeviceOptions__StyledHoverDiv",
  componentId: "sc-1gzurpg-0"
})(["&:hover{background-color:", ";}button[aria-disabled='true']{color:", ";}"], ({
  theme
}) => `${theme.color['fill-secondary-subtle']}`, ({
  theme
}) => theme.color['text-core-disabled']);
function CallDeviceOptions({
  device,
  onSelect,
  disabled,
  isHubSpotProvidedNumber
}) {
  const callMethodOptions = useMemo(() => {
    const options = [{
      key: CALL_FROM_BROWSER,
      text: 'callHostWidget.settings.callFromBrowser'
    }, {
      key: CALL_FROM_PHONE,
      text: 'callHostWidget.settings.callFromPhone',
      disabled: isHubSpotProvidedNumber,
      disabledTooltipMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "callee-phone-numbers.choosePersonalNumber"
      })
    }, {
      key: CALL_FROM_HUBSPOT_APP,
      text: 'callHostWidget.settings.callFromHubSpotApp',
      badge: /*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineStart: "200",
        children: /*#__PURE__*/_jsx(Badge, {
          use: "new",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "callHostWidget.settings.new"
          })
        })
      })
    }];
    return options;
  }, [isHubSpotProvidedNumber]);
  return /*#__PURE__*/_jsx(List, {
    wrapChildren: true,
    children: callMethodOptions.map(option => {
      const key = option.key;
      const selectedKeyOption = device;
      const title = option.disabledTooltipMessage;
      let keyString = key;
      const badge = option.badge;
      const shouldDisableTooltip = !option.disabled;
      const selected = key === selectedKeyOption;
      keyString = key;
      const Message = /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: option.text
        }), badge]
      });
      return /*#__PURE__*/_jsx(Tooltip, {
        title: title,
        disabled: shouldDisableTooltip,
        placement: "bottom",
        children: /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(StyledHoverDiv, {
            children: /*#__PURE__*/_jsx(Flex, {
              inlineSize: "100%",
              justifyContent: "space-between",
              children: /*#__PURE__*/_jsx(DropdownMenuOption, {
                selected: selected,
                onClick: () => onSelect(key),
                disabled: disabled || option.disabled,
                "data-selenium-test": `pre-call-option-${keyString}`,
                cursor: "pointer"
                /* @ts-expect-error dependent on trellis issue https://git.hubteam.com/HubSpot/foundations-components/issues/5685 */,
                use: "unstyled",
                padding: "300",
                children: Message
              }, keyString)
            })
          })
        })
      }, keyString);
    })
  });
}
CallDeviceOptions.propTypes = {
  device: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isHubSpotProvidedNumber: PropTypes.bool.isRequired
};
export default /*#__PURE__*/memo(CallDeviceOptions);